document.querySelectorAll("#country-selector").forEach(popupopen => {
	popupopen.addEventListener("click", function() {
		document.querySelectorAll(".country-language-popup").forEach(openpopup => {
			openpopup.classList.add("hidden")
		})
		document.body.style.overflow = "hidden"
	})
})

document.querySelectorAll(".cancle_buttonpopu").forEach(popuphide => {
	popuphide.addEventListener("click", function() {
		document.querySelectorAll(".country-language-popup").forEach(hidepopup => {
			hidepopup.classList.remove("hidden")
		})
		document.body.style.overflow = ""
	})
})

var links = document.querySelectorAll(".country-state_container li")

links.forEach(link => {
	link.addEventListener("click", function() {
		links.forEach(item => item.classList.remove("selected"))
		this.classList.add("selected")
	})
})

var selectedCountryLi = document.querySelector(".country-list_box li.selected")
var countryDropdown = document.getElementById("CountrySelector")

if (selectedCountryLi && countryDropdown) {
	var selectedText = selectedCountryLi.textContent.trim()

	countryDropdown.querySelectorAll("option").forEach(option => {
		if (option.textContent.trim() === selectedText) {
			option.selected = true
		}
	})
}

document.querySelectorAll(".country-list_box li").forEach(item => {
	item.addEventListener("click", function() {
		document.querySelectorAll(".country-list_box li").forEach(li => li.classList.remove("selected"))
		this.classList.add("selected")

		let selectedCountryIso = this.dataset.iso
		let countryDropdown = document.getElementById("CountrySelector")

		if (countryDropdown && selectedCountryIso) {
			countryDropdown.querySelectorAll("option").forEach(option => {
				if (option.value === selectedCountryIso) {
					option.selected = true
				}
			})
		}
	})
})

var countryPopup = document.querySelector(".country-state_container .country-popup")
var heading = document.querySelector(".language_heading h1")
var height = document.querySelector(".country-state_container .country-popup")
var border = document.querySelector(".popup-content_country-language")
var language_heading = document.querySelector(".language_heading")

let isHidden = false

if (countryPopup && heading && height && border && language_heading) {
	countryPopup.addEventListener("scroll", function() {
	requestAnimationFrame(() => {
		const scrolled = countryPopup.scrollTop > 0

		if (scrolled && !isHidden) {
			heading.classList.add("collapsing")

			heading.addEventListener("transitionend", function onCollapseEnd(e) {
				if (e.propertyName === "height") {
					heading.classList.add("hidden")
					heading.classList.remove("collapsing")
					heading.removeEventListener("transitionend", onCollapseEnd)
				}
			})

			isHidden = true
		} else if (!scrolled && isHidden) {
			heading.classList.remove("hidden") // display: block
			// Force reflow
			void heading.offsetWidth

			heading.classList.remove("collapsing") // trigger expand + fade-in
			isHidden = false
		}

		// Adjust container height/padding
		height.style.height = scrolled ? "calc(100vh - 259px)" : "calc(100vh - 330px)"
		language_heading.style.paddingTop = scrolled ? "10px" : ""
		border.style.borderBottom = scrolled ? "1px solid rgba(34, 34, 34, 0.15)" : ""
	})
	})
}

document.querySelectorAll(".overlay-custom").forEach(button_over => {
	button_over.addEventListener("click", function() {
		document.querySelectorAll("faq-single").forEach(hide => {
			hide.removeAttribute("open")
			document.body.classList.remove("overlay-open", this.hasAttribute("open"));
		})
	})
})


// Cookie utility functions
function setCookie(name, value, days) {
	const expires = new Date();
	expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
	document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

function getCookie(name) {
	const nameEQ = name + "=";
	const ca = document.cookie.split(';');
	for(let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

// Function to select country based on ISO code
function selectCountryByCode(countryCode) {
	// Find the country list item with matching data-iso
	const countryItems = document.querySelectorAll('.country-list_box li[data-iso]');
	const countryDropdown = document.getElementById('CountrySelector');
	
	countryItems.forEach(item => {
		if (item.dataset.iso === countryCode) {
			// Remove selected class from all items
			document.querySelectorAll('.country-list_box li').forEach(li => li.classList.remove('selected'));
			// Add selected class to matching item
			item.classList.add('selected');
			
			// Update the dropdown selection
			if (countryDropdown) {
				const selectedText = item.textContent.trim();
				countryDropdown.querySelectorAll('option').forEach(option => {
					option.selected = option.textContent.trim() === selectedText;
				});
			}

			item.scrollIntoView();
		}
	});
}

// Function to show the country language popup
function showCountryLanguagePopup() {
	const popup = document.getElementById('country-lang-popup');
	const overlay = document.querySelector('.overlay-custom');
	
	if (popup) {
		popup.classList.add('show');
		if (overlay) {
			overlay.classList.add('show-overlay');
		}
		document.body.classList.add('overlay-open');
		window.countryPopupVisible = true;
	}
}

// Function to hide the country language popup
function hideCountryLanguagePopup(dispatchEvent = true) {
	const popup = document.getElementById('country-lang-popup');
	const overlay = document.querySelector('.overlay-custom');
	
	if (popup) {
		popup.classList.remove('show');
		if (overlay) {
			overlay.classList.remove('show-overlay');
		}
		document.body.classList.remove('overlay-open');
		console.log('Hiding country language popup');
		// Set cookie so popup doesn't show again
		setCookie('countryPopupSeenNew-v2', 'true', 365);
		if (dispatchEvent) {
			console.log('Dispatching countryPopupHidden event');
			document.dispatchEvent(new Event('countryPopupHidden'));
			window.countryPopupVisible = false;
		}
	}
}

function showCookieBanner() {
  const banner = document.querySelector(".cookies-customize__wrapper");
  if (banner) banner.classList.add("show");
}

// Function to select country in the popup dropdown
function selectPopupCountryByCode(countryCode) {
	// Wait for dropdown to be ready
	const countryDropdown = document.querySelector('.custom-dropdown[data-dropdown="popup-country-selector"]');
	const hiddenSelect = document.getElementById('PopupCountrySelector');
	if (countryDropdown && hiddenSelect) {
		// Update the hidden select
		const hiddenOptions = hiddenSelect.querySelectorAll('option');
		hiddenOptions.forEach(option => {
			option.selected = option.value === countryCode;
		});

		// Update the visible dropdown
		const options = countryDropdown.querySelectorAll('.custom-dropdown__option');
		options.forEach(option => {
			if (option.dataset.value === countryCode) {
				// Update the selected display
				const selectedDisplay = countryDropdown.querySelector('.custom-dropdown__selected span');
				if (selectedDisplay) {
					selectedDisplay.textContent = option.dataset.label || option.textContent.trim();
				}

				const subdescriptionCountry	 = document.querySelector('.country-lang-popup__subdescription .country-name');
				if (subdescriptionCountry) {
					subdescriptionCountry.textContent = option.dataset.label || option.textContent.trim();
				}

				// Update option states
				countryDropdown.querySelectorAll('.custom-dropdown__option').forEach(opt => {
					opt.classList.remove('custom-dropdown__option--selected');
				});
				option.classList.add('custom-dropdown__option--selected');
			}
		});

		let selectedValue = document.querySelector('#popup-country-selector .custom-dropdown__selected span');
		selectedValue = selectedValue ? selectedValue.textContent : '';

		// Dispatch change event AFTER all UI updates are complete
		hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));

	}

	setTimeout(() => {
		document.querySelector('#PopupCountryForm').submit();
		console.log('Submitted popup country form after selection');
	}, 500);
}

// Function to select language in the popup dropdown
function selectPopupLanguageByName(languageName) {
	const languageDropdown = document.querySelector('.custom-dropdown[data-dropdown="popup-language-selector"]');
	
	if (languageDropdown) {
		// Update the visible dropdown
		const options = languageDropdown.querySelectorAll('.custom-dropdown__option');
		options.forEach(option => {
			const optionText = option.dataset.label || option.textContent.trim();
			if (optionText === languageName) {
				// Update the selected display
				const selectedDisplay = languageDropdown.querySelector('.custom-dropdown__selected span');
				if (selectedDisplay) {
					selectedDisplay.textContent = languageName;
					selectedDisplay.parentElement.classList.remove('placeholder');
				}
				
				// Update option states
				languageDropdown.querySelectorAll('.custom-dropdown__option').forEach(opt => {
					opt.classList.remove('custom-dropdown__option--selected');
				});
				option.classList.add('custom-dropdown__option--selected');
			}
		});
	}
}

// Check if user has seen country popup before
async function checkCountryPopupCookie() {
	const hasSeenPopup = getCookie('countryPopupSeenNew-v2');
	if (!hasSeenPopup) {
		try {
			setTimeout(async () => {

				// Get user's country code from orbito
				const remoteCountryCode = await orbito.getRemoteCountryCode();
				if (remoteCountryCode) {
					// Select the country based on remote country code in the popup
					console.log('Selecting country in popup based on remote country code:', remoteCountryCode);
					setCookie('countryPopupSeenNew-v2', remoteCountryCode, 365); // Store for 1 day
					selectPopupCountryByCode(remoteCountryCode);
				}
			}, 1000);
		} catch (error) {
			console.log('Could not get remote country code:', error);
		}
		
		// Update language dropdown with current Weglot language
		setTimeout(() => {
			if (typeof Weglot !== 'undefined') {
				try {
					let currentLang = Weglot.getCurrentLang();
					if (currentLang) {
						let languageName = Weglot.getLanguageName(currentLang);
						if (languageName) {
							selectPopupLanguageByName(languageName);
						}
					}
				} catch (error) {
					console.log('Could not get Weglot language:', error);
				}
			}
		}, 600);
		
		// Show the new country language popup
		//showCountryLanguagePopup();
	} else {
		console.log('Country popup already seen');
		document.dispatchEvent(new Event('countryPopupHidden'));
		window.countryPopupVisible = false;
	}
}

document.addEventListener("DOMContentLoaded", function() {
	if (Shopify.designMode) return;

	let closeButton = document.querySelector('.country-lang-popup__close');
	// Check and show country popup for first-time visitors
	checkCountryPopupCookie();

	// Add event listeners for popup dropdown changes
	const popupCountryDropdown = document.querySelector('[data-dropdown="popup-country-selector"]');
	const popupHiddenSelect = document.getElementById('PopupCountrySelector');

	if (popupCountryDropdown && popupHiddenSelect) {
		// Listen for custom dropdown change event
		popupCountryDropdown.addEventListener('dropdown-change', function(e) {
			const selectedValue = e.detail.value;

			// Update hidden select
			const hiddenOptions = popupHiddenSelect.querySelectorAll('option');
			hiddenOptions.forEach(hiddenOption => {
				hiddenOption.selected = hiddenOption.value === selectedValue;
			});

			// Dispatch change event to notify the form of the selection
			popupHiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));

			console.log('Country selected in popup:', selectedValue);
		});
	}

	// Add event listener for language dropdown changes
	const popupLanguageDropdown = document.querySelector('[data-dropdown="popup-language-selector"]');
	const popupLanguageInput = document.getElementById('popup-language-code');

	if (popupLanguageDropdown && popupLanguageInput) {
		// Listen for custom dropdown change event
		popupLanguageDropdown.addEventListener('dropdown-change', function(e) {
			const selectedLanguageCode = e.detail.value;
			const link = e.detail.link;

			// Update hidden language_code input
			popupLanguageInput.value = selectedLanguageCode;

			console.log('Language selected in popup:', selectedLanguageCode);

			// If the option has a Weglot link, trigger Weglot language switch
			if (link && link.href && link.href.includes('#Weglot-')) {
				const weglotLangCode = selectedLanguageCode;
				if (typeof Weglot !== 'undefined' && Weglot.switchTo) {
					Weglot.switchTo(weglotLangCode);
					console.log('Switched Weglot to:', weglotLangCode);
				}
			}
		});
	}

	// Add event listener for the form submission
	const popupForm = document.getElementById('PopupCountryForm');
	if (popupForm) {
		popupForm.addEventListener('submit', function() {
			// Form will submit normally to update localization
			console.log('Submitting localization form');
			hideCountryLanguagePopup(false);
			//showCookieBanner();
		});
	}

	if (closeButton) {
		closeButton.addEventListener('click', function() {
			hideCountryLanguagePopup();
		});
	}

	// Add click listener to overlay to close popup
	const overlay = document.querySelector('.overlay-custom');
	if (overlay) {
		overlay.addEventListener('click', function() {
			const popup = document.getElementById('country-lang-popup');
			if (popup && popup.classList.contains('show')) {
				hideCountryLanguagePopup();
			}
		});
	}

	// Update popup language dropdown with current Weglot language
	function updatePopupLanguage() {
		if (typeof Weglot !== 'undefined') {
			try {
				let currentLang = Weglot.getCurrentLang();
				if (currentLang) {
					let languageName = Weglot.getLanguageName(currentLang);
					if (languageName) {
						selectPopupLanguageByName(languageName);
					}
				}
			} catch (error) {
				console.log('Could not get Weglot language:', error);
			}
		}
	}

	// Update existing language dropdown (for the old country popup)
	let currentLang = Weglot && Weglot.getCurrentLang ? Weglot.getCurrentLang() : null;
	if (currentLang) {
		let languageDropdown = document.querySelector(".country-language-popup #FooterCountryForm .custom-dropdown__selected.placeholder span");
		if (languageDropdown) {
			languageDropdown.textContent = Weglot.getLanguageName(currentLang);
		}
		// Also update the popup language dropdown
		updatePopupLanguage();
	} else if (typeof Weglot !== 'undefined') {
		Weglot.on("initialized", () => {
			let languageDropdown = document.querySelector(".country-language-popup #FooterCountryForm .custom-dropdown__selected.placeholder span");
			let language = Weglot.getCurrentLang();
			if (languageDropdown) {
				languageDropdown.textContent = Weglot.getLanguageName(language);
			}
			// Also update the popup language dropdown
			updatePopupLanguage();
		});
	}

	let preferencesButton = document.querySelector('.country-language-popup .update-btn');
	if (preferencesButton) {
		preferencesButton.addEventListener('click', function() {
			setCookie('countryPopupSeenNew-v2', 'true', 365); // Expires in 1 year
		});
	}

	let updateButton = document.querySelector('.country-language-popup .update-btn');
	let languageDropdownOptions = document.querySelectorAll('.custom-dropdown[data-dropdown="language-selector"] .weglot-link');
	languageDropdownOptions.forEach(option => {
		option.addEventListener('click', function() {
			updateButton.setAttribute('disabled', 'disabled');
			setTimeout(() => {
				updateButton.removeAttribute('disabled');
			}, 1500);
		});
	});

	/*
	let geoSubmit = document.getElementById("md-btn__form__onSubmit");
	geoSubmit.addEventListener("click", function(e) {
		let currentLang = document.querySelector('#orbeLanguageList .md-form__select__language__list-link[aria-current="true"]');
		if (currentLang) {
			let language = currentLang.dataset.value
			Weglot.switchTo(language);
			document.querySelector('.md-modal__container #md-modal__form__id input[name="language_code"]').remove();
			let form = document.querySelector('.md-modal__container #md-modal__form__id');
			let formData = new FormData(form);
			let languageCode = formData.get('language_code');
			e.preventDefault();
			e.stopPropagation();
			debugger;
			return;
		}
	});*/
});
